import React from 'react';
import { SafeAreaProvider } from 'react-native-safe-area-context';

import { createNativeStackNavigator } from '@react-navigation/native-stack';

import { FantasyPickSlip } from '@/feature/betslip-pickem/screens/FantasyPickSlip';
import { SubmitEntryScreen } from '@/feature/betslip-pickem/screens/SubmitEntry';
import { screenPresets } from '@/navigation/screen-presets';
import { FantasyPickSlipStackParamList } from '@/navigation/types';
import { common } from '@/styles/styles';

const Stack = createNativeStackNavigator<FantasyPickSlipStackParamList>();

export const FantasyPickSlipStack = () => (
    <SafeAreaProvider style={common.flex}>
        <Stack.Navigator screenOptions={screenPresets.modalStack}>
            <Stack.Screen name="FantasyPickSlip" component={FantasyPickSlip} />
            <Stack.Screen name="SubmitEntry" component={SubmitEntryScreen} options={screenPresets.gestureDisabled} />
        </Stack.Navigator>
    </SafeAreaProvider>
);
